var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLinkExternal = function SvgLinkExternal(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19L5 19L5 5L12 5V3L5 3C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5L3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21L19 21C20.1 21 21 20.1 21 19L21 12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10L21 10V3L14 3Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkExternal);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xOSAxOUw1IDE5TDUgNUwxMiA1VjNMNSAzQzQuNDY5NTcgMyAzLjk2MDg2IDMuMjEwNzEgMy41ODU3OSAzLjU4NTc5QzMuMjEwNzEgMy45NjA4NiAzIDQuNDY5NTcgMyA1TDMgMTlDMyAxOS41MzA0IDMuMjEwNzEgMjAuMDM5MSAzLjU4NTc5IDIwLjQxNDJDMy45NjA4NiAyMC43ODkzIDQuNDY5NTcgMjEgNSAyMUwxOSAyMUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlMMjEgMTJIMTlWMTlaTTE0IDNWNUgxNy41OUw3Ljc2IDE0LjgzTDkuMTcgMTYuMjRMMTkgNi40MVYxMEwyMSAxMFYzTDE0IDNaIgogICAgICAgICAgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";